import { useFormik } from "formik";
import Modal from "../Modal/Modal";
import OTP from "../../Formik/OTP/OTP";
import Button from "../../Button/Button";
import { useEffect, useState } from "react";
import styles from "./ViewCardOtpModal.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { SERVICESTYPE } from "../../../../utils/constants";
import { generateOTPAction } from "../../../../features/user/userSlice";
import emailStyles from "../../../../components/pages/OnboardScreens/EmailVerification/EmailVerification.module.scss";

const ViewCardOtpModal = ({ show, handleClose, onSubmitAction, loading }) => {
  const dispatch = useDispatch();
  const [seconds, setSeconds] = useState();
  const [timer, setTimer] = useState(60);
  const [showBtn, setShowBtn] = useState(false);
  const userData = useSelector((state) => state?.persist?.userInfo);

  const formik = useFormik({
    initialValues: {
      otp: "",
    },
    onSubmit: (values) => {
      onSubmitAction(values);
    },
  });


  useEffect(() => {
    if (!show) {
      formik.resetForm();
    }
  }, [show]);

  const generateOTP = async () => {
    const data = {
      username: await userData?.email,
      type: SERVICESTYPE?.EMAIL,
      service: "CARD_SECRETS",
    };
    try {
      const response = await dispatch(generateOTPAction(data));
      if (response?.status === 200) {
        reSetTime();
      }
    } catch (error) {
      console.log("Something went wrong:", error);
    }
  };

  const setTime = () => {
    if (!seconds || seconds > 0) {
      const timer = setInterval(() => {
        setSeconds((second) => {
          if (second <= 0) {
            return clearInterval(timer);
          }
          return second - 1;
        });
      }, 1000);
    }
  };

  const reSetTime = () => {
    setSeconds(180); // 3 minutes in seconds
    setTime();
  };

  const handleResend = () => {
    generateOTP();
    setTimer(56);  // reset timer
    setShowBtn(false);
  };

  useEffect(() => {
    generateOTP()
  }, [])


  useEffect(() => {
    let interval;

    if (timer > 0) {
      setShowBtn(false);
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else {
      setShowBtn(true);
    }

    return () => clearInterval(interval);
  }, [timer]);

  return (
    <Modal
      show={show}
      handleClose={handleClose}
      title={"Enter OTP to view card"}
      className={styles.add_pin_modal}
    >
      <form onSubmit={(e) => { e.preventDefault(); e.stopPropagation(); }}>
        <OTP
          label="Enter OTP"
          name="otp"
          value={formik.values.otp}
          onChange={(value) => {
            formik.setFieldValue("otp", value);
          }}
          onBlur={formik.handleBlur}
          formik={formik}
          placeholder="------"
        />
        <div className={emailStyles.btn_restotp}>
          {showBtn ? (
            <Button
              className={` ${emailStyles.restBtn}`}
              onClick={handleResend}
              type="button"
              variant="without_bg_border"
            >
              Re send
            </Button>
          ) : (
            <p>Re send verification code in {timer}s</p>
          )}
        </div>
        <Button
          fluid
          className={styles.btn_pin}
          type="button"
          disabled={loading}
          onClick={(e) => {
            formik.handleSubmit(e);
          }}
        >
          {loading ? "Loading..." : "Continue"}
        </Button>
      </form>
    </Modal>
  );
};

export default ViewCardOtpModal;
